import { type HTMLProps } from 'react';

import { omit, pick } from 'ramda';

import { FLOATING_TRIGGER_PROPS } from './Floating.constants';

export const useFloatingTriggerProps = (
    props: Pick<
        HTMLProps<HTMLDivElement> & { 'data-state'?: 'open' | 'closed' },
        (typeof FLOATING_TRIGGER_PROPS)[number]
    >
) => {
    return [pick(FLOATING_TRIGGER_PROPS, props), omit(FLOATING_TRIGGER_PROPS, props)] as const;
};
